import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import { faqData } from '../data/FaqData';
import PageHeader from '../components/PageHeader';
import ScrollReveal, { StaggerReveal, StaggerItem } from '../components/ScrollReveal';

const FAQItem = ({ question, answer, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <StaggerItem>
      <div className={`border-b border-stone-100 last:border-0 transition-colors ${open ? 'bg-stone-50' : ''}`}>
        <button
          className="flex justify-between items-center w-full text-left py-5 px-6 gap-4"
          onClick={() => setOpen(!open)}
        >
          <div className="flex items-center gap-4">
            <span className="text-xs font-semibold text-stone-300 tabular-nums w-5 shrink-0">
              {String(index + 1).padStart(2, '0')}
            </span>
            <span className="font-semibold text-stone-950 text-sm leading-snug">{question}</span>
          </div>
          <motion.span animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.2 }} className="text-stone-400 shrink-0">
            <FaChevronDown size={13} />
          </motion.span>
        </button>
        <AnimatePresence initial={false}>
          {open && (
            <motion.div
              key="body"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.25 }}
              className="overflow-hidden"
            >
              <div className="px-6 pb-5 pl-[3.75rem] text-sm text-stone-500 leading-relaxed">
                {answer}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </StaggerItem>
  );
};

const FAQ = ({ setCurrentSection, currentSection, setActiveTab }) => {
  useEffect(() => { window.scrollTo(0, 0); }, [currentSection]);

  return (
    <>
      <PageHeader
        title="FAQ"
        subtitle="Toutes les réponses à vos questions sur le club"
        setCurrentSection={setCurrentSection}
        currentSection={currentSection}
      />
      <section className="section bg-stone-50">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="card-minimal overflow-hidden max-w-3xl">
              <StaggerReveal>
                {faqData.map((item, i) => (
                  <FAQItem
                    key={i}
                    index={i}
                    question={item.question}
                    answer={<item.answer setCurrentSection={setCurrentSection} setActiveTab={setActiveTab} />}
                  />
                ))}
              </StaggerReveal>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </>
  );
};

export default FAQ;
